import { render, staticRenderFns } from "./Social.vue?vue&type=template&id=5ecb3d1e&"
import script from "./Social.vue?vue&type=script&lang=ts&"
export * from "./Social.vue?vue&type=script&lang=ts&"
import style0 from "./Social.vue?vue&type=style&index=0&id=5ecb3d1e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports